export default "__VITE_ASSET__BwbVhLlK__"